import { StudioClipListProps as PropsType } from './StudioClipList';

export { default } from './StudioClipList';
export type StudioClipListProps = PropsType;
